import React from "react";

function DashboardAdmin() {
  return (
    <div className="container mt-5">
      <h2>4Party Dashboard</h2>
      <p>Welcome,party4</p>
    </div>
  );
}

export default DashboardAdmin;